import { InjectionToken, Type } from '@angular/core';

export const DIALOG_BASIC_COMPONENT = new InjectionToken<Type<any>>(
  'DialogBasicComponent'
);
export const DIALOG_LOADING_COMPONENT = new InjectionToken<Type<any>>(
  'DialogLoadingComponent'
);
